import React from 'react';
import type { Icon } from './types';

export const Bus: Icon = ({ className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        className={className}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13 11.5H16V10.5H13V11.5ZM4 11.5H7V10.5H4V11.5ZM17 13.5H13.9915H6.013H3V8.5H9.5H10.5H17V13.5ZM17 15.5C17 16.0515 16.5515 16.5 16 16.5C15.4485 16.5 15 16.0515 15 15.5V14.5H17V15.5ZM5 15.5C5 16.0515 4.5515 16.5 4 16.5C3.4485 16.5 3 16.0515 3 15.5V14.5H5V15.5ZM3 1.5H17L17.0065 7.5H10.5V3.5H9.5V7.5H3V1.5ZM18 3.5V0.5H2V3.5H0.0025H0V6.5H1V4.5H2V15.5C2 16.6045 2.8955 17.5 4 17.5C5.1045 17.5 6 16.6045 6 15.5V14.5H14V15.5C14 16.6045 14.8955 17.5 16 17.5C17.1045 17.5 18 16.6045 18 15.5V4.5H19V6.5H20V3.5H18Z"
            fill="#3659E3"
        />
    </svg>
);
